import ILogger, { defaultLoggingConfiguration, ILoggingConfiguration, logLevel } from "@HisPlatform/Services/Definition/Logger/ILogger";
import { TypedEvent } from "@Toolkit/CommonWeb/TypedEvent";

export default class QueuedLogger implements ILogger {
    public configuration: ILoggingConfiguration = defaultLoggingConfiguration;
    public readonly logEvent = new TypedEvent<string>();

    private entries: IInMemoryLoggerLogEntry[] = [];
    private currentUserName: string = null;
    
    public configure(configuration: ILoggingConfiguration): void {
        this.configuration = configuration;
    }
    
    public log(value: any, level: logLevel, additionalMessage?: string): void {
        this.entries.push({
            value,
            level,
            additionalMessage,
            userName: this.currentUserName,
        });
    }
    
    public initializeUserName(userName: string): void {
        this.currentUserName = userName;
    }

    public dequeueAllEntrties() {
        const result = this.entries;
        this.entries = [];
        return result;
    }
    
}

interface IInMemoryLoggerLogEntry {
    value: any; 
    level: logLevel;
    additionalMessage?: string;

    userName?: string;
}